import { archiveDeleteProjects } from "./archivedProjectsApi";

const ARCHIVE_CONFIRM_SUFFIX =
  "Data is kept in the archive database and can be restored by an administrator.";

export function buildArchiveDeleteConfirmMessage(label) {
  return `Archive and remove ${label} from the board? ${ARCHIVE_CONFIRM_SUFFIX}`;
}

export async function confirmAndArchiveDeleteProjects(ids, { label }) {
  const uniqueIds = [...new Set((ids || []).map((id) => Number(id)).filter(Number.isFinite))];
  if (uniqueIds.length === 0) {
    return { cancelled: true, archived: 0 };
  }
  if (!window.confirm(buildArchiveDeleteConfirmMessage(label))) {
    return { cancelled: true, archived: 0 };
  }
  const result = await archiveDeleteProjects(uniqueIds);
  return { cancelled: false, ...result };
}
